import React, { useState, useEffect } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Snackbar from '@material-ui/core/Snackbar';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { VerifiedUserSharp } from '@material-ui/icons';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { FacebookProvider, LoginButton } from 'react-facebook';
import Header from '../com/Header'
import queryString from 'query-string';
import { useCookies } from 'react-cookie';
var md5 = require('md5');
 
// import { authenticate } from './auth';
// import Cookies from 'js-cookie'

// import { useAuth } from "./context/auth";

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="#">
                DigicelLIVE
      </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: '#E61A2E',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        textTransform: 'none',
        fontSize: "1.2em"
    },
    mainCon:{
        textAlign:'center'
        // background: 'linear-gradient(45deg, #D82C5F 30%, #B810C4 90%)',
    },
    fbButton:{
        width:'100%',
        background: '#4267B2',
        color: 'white',
        fontSize: '1.2em',
        fontWeight: '500',
        border:"1px solid #888",
        borderRadius: "3px",
        padding: "9px"
    }
}));

export default function Home(props) {
    const history = useHistory(); 
    const classes = useStyles();
    const [nickname, setNickname] = useState("");
    const [password, setPassword] = useState("");
    const [isLoggedIn, setLoggedIn] = useState(false);
    const [show, setShow] = useState(false);
    const [alertMsg, setAlertMessage] = useState("");
    

    let q = queryString.parse(props.location.search)
    const [cookies, setCookie] = useCookies();


    if(q.goto === '' || typeof(q.goto) == 'undefined' || q.goto == undefined){
        setCookie('goto', 'https://mydigicellive.com', { path: '/', maxAge:180, sameSite: true, secure: true   });   
    } else{
        setCookie('goto', q.goto, { path: '/', maxAge:180, sameSite: true, secure: true   });   
    }
   
    setCookie('eref', md5(Math.random()*Math.floor(1000)), { path: '/',domain: ".mydigicellive.com", maxAge:180, sameSite: true, secure: true   });   

    const handleError = (err) => {
        console.log(err);
    } 
       const handleResponse = (res) => {
        console.log(res);
        let nick_name = (res.profile.shortname)?res.profile.shortname:res.profile.first_name
        let pic = (res.profile.picture.data)?res.profile.picture.data.url:''
        history.push({
            pathname:"/signup",
            data:{
                nickname: nick_name,
                email: res.profile.email,
                picture: pic,
                eref: cookies.eref

             }
           });
    }

    const hasProfile = () =>{
        fetch('https://mydigicellive.com/ms/echo_profile.php', {
            method: 'GET'
        }).then(res => res.json())
            .then(json => {
                
                if(json.has_profile){
                    //redirect to 
                    if(typeof(q.goto) == 'undefined' || q.goto == undefined ||  q.goto == ''){
                    // if(typeof(cookies.goto) == 'undefined' || cookies.goto == 'undefined'){
                        window.location.href = 'https://mydigicellive.com'
                    } else{

                        if(q.goto !== '' && q.goto != undefined) {
                            window.location.href = q.goto;
                        } else {
                            window.location.href = 'https://mydigicellive.com'
                        }
                       
                    }
                }
                
            })
            .catch((err) => {
                console.log(err, "mess")
            })
    }
    hasProfile()

    // let login = async () => {
    //     await authenticate(email, password)
    //         .then(res => {
    //             if (res.token) { //logged in
    //                 var sessionExpire = new Date(new Date().getTime() + (60 * 3) * 60 * 1000); //(mins)/secs/milli-secs
    //                 Cookies.set('__session', res.token, { expires: sessionExpire });
    //                 //if (!mountedRef.current) return null;
    //                 setLoggedIn(true);
    //             } else {
    //                 setAlertMessage(res.message);
    //                 setShow(true);
    //                 setLoggedIn(false);
    //             }
    //         })
    //         .catch(err => {
    //             setAlertMessage(err.message);
    //             setShow(true);
    //             setLoggedIn(false);
    //         });
    // }
    const handleCloseSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setShow(false);
    };
    // const handleSubmit = (event) => {
    //     event.preventDefault();
    //     // login();
    // }
    const gotoSignup = () =>{

        // history.push("/signup");
        history.push({
            pathname:"/signup",
            data:{
                // nickname: "PJ",
                // email: "info@pj.com"
             }
           });
        
        // <Redirect to="/home" />
        // history.push("/signup")
        // alert(4);
    }

    // if (isLoggedIn) { //state update
    //     return <Redirect to="/home" />;
    // }

    return (
       
        <Container component="main" maxWidth="xs" className={classes.mainCon}>
            <CssBaseline />
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <AccountCircleIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                   Chat with friends.    
                </Typography>
                <Typography component="h1" variant="h5">
                   Play games and win.    
                </Typography>
                {/* <form className={classes.form} onSubmit={handleSubmit}> */}
                    
                    <Button
                        // type="submit"
                        fullWidth
                        variant="contained"
                        color="secondary"
                        className={classes.submit}
                        onClick={gotoSignup}
                        // disabled={!validateForm()}
                    >
                       Continue with DigicelLIVE
          </Button>
          {/* <FacebookProvider appId="1067167613720509">
        <LoginButton
            className={classes.fbButton}
          scope="email"
          onCompleted={handleResponse}
          onError={handleError}
        >
          <span>Log in with Facebook</span>
        </LoginButton>
      </FacebookProvider> */}
   
            </div>
            <Box mt={8}>
                <Copyright />
            </Box>
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={show}
                autoHideDuration={2000}
                onClose={handleCloseSnackBar}
                message={alertMsg}
            />
        </Container>
    );
}